"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unused-vars
const noop = (...args) => {
    /* Dummy function for when you need a callback that does nothing */
};
exports.noop = noop;
